import Vue from 'vue'
import VueRouter from 'vue-router'
//import Home from '../views/Home.vue'
import store from '../store'
import i18n from '../i18n'
import Staff from '../model/instance/Staff'
import config from '../../config.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    //component: Home
    redirect: { name: 'Login' }
  }
  ,{name:'Login',path: '/login',component: () => import('../components/Login/Login.vue')}
  ,{name:'Error',path: '/error',component: () => import('../components/Common/Error.vue')}

  ,{name:'Dashboard_0',path: '/manage/dashboard',component: () => import('../components/Dashboard/Dashboard_0.vue')}
  ,{name:'Dashboard',path: '/manage/dashboard/:station_code',component: () => import('../components/Dashboard/Dashboard.vue')}
  ,{name:'Staff',path: '/manage/staff',component: () => import('../components/Staff/Staff.vue')}
  ,{name:'StaffDetail',path: '/manage/staff/:staff_id',component: () => import('../components/Staff/StaffDetail.vue')}
  ,{name:'Station',path: '/manage/station',component: () => import('../components/Station/Station.vue')}
  ,{name:'Station_Detail',path: '/manage/station/:station_code',component: () => import('../components/Station/StationDetail.vue')}
  ,{name:'Member_0',path: '/manage/member',component: () => import('../components/Member/Member_0.vue')}
  ,{name:'Member',path: '/manage/member/:station_code',component: () => import('../components/Member/Member.vue')}
  ,{name:'Appointment_Guide_0',path: '/manage/appointment/guide',component: () => import('../components/AppointmentGuide/AppointmentGuide_0.vue')}
  ,{name:'Appointment_Guide',path: '/manage/appointment/guide/:station_code',component: () => import('../components/AppointmentGuide/AppointmentGuide.vue')}
  ,{name:'Appointment_List_0',path: '/manage/appointment/list',component: () => import('../components/AppointmentList/AppointmentList_0.vue')}
  ,{name:'Appointment_List',path: '/manage/appointment/list/:station_code',component: () => import('../components/AppointmentList/AppointmentList.vue')}
  ,{name:'Appointment_List_Report_0',path: '/manage/appointment/listreport',component: () => import('../components/AppointmentListReport/AppointmentListReport_0.vue')}
  ,{name:'Appointment_List_Report',path: '/manage/appointment/listreport/:station_code',component: () => import('../components/AppointmentListReport/AppointmentListReport.vue')}
  
  ,{name:'Appointment_Group_0',path: '/manage/appointment/group',component: () => import('../components/AppointmentGroup/AppointmentGroup_0.vue')}
  ,{name:'Appointment_Group',path: '/manage/appointment/group/:station_code',component: () => import('../components/AppointmentGroup/AppointmentGroup.vue')}
  ,{name:'Appointment_Group_Detail',path: '/manage/appointment/group/:station_code/:group_id',component: () => import('../components/AppointmentGroup/AppointmentGroupDetail.vue')}
  ,{name:'Automessage_0',path: '/manage/automessage',component: () => import('../components/Automessage/Automessage_0.vue')}
  ,{name:'Automessage',path: '/manage/automessage/:station_code',component: () => import('../components/Automessage/Automessage.vue')}
  ,{name:'Admin_Noti',path: '/manage/admin/noti',component: () => import('../components/AdminNoti/AdminNoti.vue')}
  
  
  ,{name:'Package',path: '/manage/package',component: () => import('../components/Package/Package.vue')}
  ,{name:'ExtPackage',path: '/manage/extpackage',component: () => import('../components/ExtPackage/ExtPackage.vue')}
  ,{name:'CustomerPackage',path: '/manage/customerpackage',component: () => import('../components/CustomerPackage/CustomerPackage.vue')}
  ,{name:'CustomerBilling_0',path: '/manage/customerbilling',component: () => import('../components/CustomerBilling/CustomerBilling_0.vue')}
  ,{name:'CustomerBilling',path: '/manage/customerbilling/:station_code',component: () => import('../components/CustomerBilling/CustomerBilling.vue')}
  ,{name:'Customer',path: '/manage/customer',component: () => import('../components/Customer/Customer.vue')}

  ,{name:'Manual',path: '/manage/manual'}
  ,{name:'Logout',path: '/logout',component: () => import('../components/AdminNoti/AdminNoti.vue')}

  ,{name:'Special_Market_Setting',path: '/special/market/setting',component: () => import('../components/Special/SpecialMarketSetting.vue')}
  ,{name:'Special_Market_Order',path: '/special/market/order',component: () => import('../components/Special/SpecialMarketOrder.vue')}

  ,{name:'Dashboard_02',path: '/manage/dashboard2',component: () => import('../components/Dashboard2/Dashboard_0.vue')}
  ,{name:'Dashboard2',path: '/manage/dashboard2/:station_code',component: () => import('../components/Dashboard2/Dashboard.vue')}
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const public_url = ['Home','Login','Error']
router.beforeEach((to, from, next) => {
  i18n.locale = Staff.getLang()
  if(!public_url.includes(to.name) && !Staff.isLogin()){
    store.commit('setToName',to.name)
    next({ name: 'Login' })
  }else if(to.name=='Login' && Staff.isLogin()){
    next({ name: 'Dashboard_0' })
  }else if(to.name=='Logout'){
    Staff.setToken(null)
    next({ name: 'Login' })
  }else if(to.name=='Manual'){
      window.open(config.manaul_file, '_blank');
      next(from)
  }else{
    next()
  }
})

export default router
